import type { FC, ReactNode } from 'react'

import { Eyebrow } from '@/components/generals/section-heading'
import Container from '@/components/generals/container'

interface PageHeaderProps {
    eyebrow: string
    title: ReactNode
    lead?: ReactNode
    children?: ReactNode
}

const PageHeader: FC<PageHeaderProps> = ({ eyebrow, title, lead, children }): ReactNode => {
    return (
        <header className='border-b border-taupe bg-ivory'>
            <Container className='pb-14 pt-14 sm:pt-20 lg:pb-20 lg:pt-24'>
                <Eyebrow className='animate-in fade-in duration-700 fill-mode-backwards motion-reduce:animate-none'>
                    {eyebrow}
                </Eyebrow>

                <h1 className='mt-6 max-w-4xl font-heading text-[3rem] leading-[0.98] tracking-[-0.02em] text-ink animate-in fade-in slide-in-from-bottom-4 duration-900 ease-out-soft delay-100 fill-mode-backwards motion-reduce:animate-none sm:text-[4.25rem] lg:text-[5.25rem]'>
                    {title}
                </h1>

                {lead && (
                    <p className='mt-6 max-w-2xl text-[17px] leading-relaxed text-ink-soft animate-in fade-in slide-in-from-bottom-2 duration-800 ease-out-soft delay-200 fill-mode-backwards motion-reduce:animate-none'>
                        {lead}
                    </p>
                )}

                {children}
            </Container>
        </header>
    )
}

export default PageHeader
